export default class ConstVar {
    static redirectUrl = "redirectUrl";
    static loginSession = "loginSession";
    static loginRole = "loginRole";
    static loginSession = "loginSession";
    static loginSessionProfile = "loginSessionProfile";
    
}
